import React, { useState } from "react"
import { manageEstateDelete } from "../../../../api/manage_estate_delete"
import { ManageEstateData } from "../"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../../../LoadingContext"

import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

interface ManageEstateDeleteProps {
  onClose: (num: number) => void // モーダルを閉じるためのコールバック
  estateData: ManageEstateData // 編集するサービス提供元データをプロパティとして受け取る
}

const ManageEstateDelete: React.FC<ManageEstateDeleteProps> = ({ onClose, estateData }) => {
  const { startLoading, stopLoading } = useLoading()
  const navigate = useNavigate()
  const [formData] = useState({
    id: estateData.id,
    name: estateData.name,
    address: estateData.address,
    phone: estateData.phone
  })

  const [errors, setErrors] = useState({
    id: "",
    name: "",
    address: "",
    phone: "",
    server: ""
  })

  const convertEnabledValues = (data: any) => {
    return data
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    // バリデーション成功時の処理
    const validationErrors = { ...errors }
    validationErrors.server = ""
    setErrors(validationErrors)

    try {
      startLoading()
      const convertedData = convertEnabledValues(formData)
      await manageEstateDelete(convertedData.id)
      onClose(1)
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        navigate("/login") // セッション切れ時にトップページへリダイレクト
      } else if (error.response) {
        const errorDetail = error.response.data.detail
        const validationErrors = { ...errors }
        validationErrors.server = errorDetail.message
        setErrors(validationErrors)
      } else {
        const validationErrors = { ...errors }
        validationErrors.server = "サーバーへの接続に失敗しました"
        setErrors(validationErrors)
      }
    } finally {
      stopLoading()
    }
  }

  return (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: "calc(100vh - 100px)",
          marginTop: "50px",
          marginBottom: "50px",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "8px 16px",
            boxSizing: "border-box"
          }}
        >
          <MDTypography variant="h4" fontWeight="medium" style={{ flex: 1, textAlign: "left" }}>
            不動産業者を削除
          </MDTypography>
          <button
            className="close-button"
            onClick={() => onClose(0)}
            style={{
              position: "absolute",
              right: 16,
              top: 8,
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer"
            }}
          >
            ×
          </button>
        </div>
        <MDBox style={{ height: "20px" }}></MDBox>
        <MDBox
          style={{
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            paddingTop: "10px",
            paddingLeft: "5px",
            paddingRight: "25px"
          }}
        >
          <MDBox display="flex" alignItems="center" gap={1} mb={2}>
            <MDInput
              label="不動産業者ID"
              type="text"
              name="id"
              value={formData.id}
              sx={{ width: "100%" }}
              inputProps={{ readOnly: true }}
            />
          </MDBox>
          <MDBox display="flex" alignItems="center" gap={1} mb={2}>
            <MDInput
              label="不動産業者名"
              type="text"
              name="name"
              value={formData.name}
              sx={{ width: "100%" }}
              inputProps={{ readOnly: true }}
            />
          </MDBox>
          {errors.name && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.name}
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" gap={1} mb={2}>
            <MDInput
              label="住所"
              type="text"
              name="address"
              value={formData.address}
              sx={{ width: "100%" }}
              inputProps={{ readOnly: true }}
            />
          </MDBox>
          {errors.address && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.address}
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" gap={1} mb={2}>
            <MDInput
              label="電話番号"
              type="text"
              name="phone"
              value={formData.phone}
              sx={{ width: "100%" }}
              inputProps={{ readOnly: true }}
            />
          </MDBox>
          {errors.phone && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.phone}
            </MDBox>
          )}
          {errors.server && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.server}
            </MDBox>
          )}
          <MDBox mt={4} mb={2}>
            <MDButton
              variant="contained"
              color="info"
              fullWidth
              sx={{
                borderRadius: "4px",
                textTransform: "none",
                fontSize: "1rem",
                padding: "0.75rem 0",
                backgroundColor: "#1976d2",
                "&:hover": {
                  backgroundColor: "#1565c0"
                }
              }}
              onClick={(e) => {
                handleSubmit(e)
              }}
            >
              削除
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </div>
  )
}

export default ManageEstateDelete
